import type { DividerProps } from '../../../assets/Divider/Divider';
import { Divider } from '../../../assets/Divider/Divider';
import { styled } from '../../../stitches.config';

export const fieldDividerDisplay = '$$fieldDividerDisplay';

const FieldDividerDraw = styled(Divider, {
  display: fieldDividerDisplay,

  variants: {
    fieldContext: {
      primary: {
        paddingTop: '$12',
      },
      secondary: {
        paddingTop: '$10',
      },
    },
  },
});
FieldDividerDraw.displayName = 'FieldDividerDraw';

// We omit the `context` from `DividerProps` since context has a different meaning for field related dividers.
type FieldDividerProps = Omit<DividerProps, 'context'> & { context?: 'primary' | 'secondary' };

export function FieldDivider({
  appearance = 'thin',
  context = 'primary',
  direction = 'row',
  variant = 'neutral',
}: FieldDividerProps) {
  return (
    <FieldDividerDraw
      appearance={appearance}
      fieldContext={context}
      direction={direction}
      variant={variant}
    />
  );
}
